import { LockKeyhole } from "lucide-react";

import {
  MYGA_AGENCY_DISCLOSURE,
  MYGA_GUARANTEE_DISCLOSURE,
  MYGA_ISSUANCE_DISCLOSURE,
} from "@/apps/charm/lib/myga/disclosure-text";
import { cn } from "@/lib/utils";

export function MygaShellFooter(props: {
  comparing: boolean;
  className?: string;
}) {
  const { comparing, className } = props;
  return (
    <footer
      className={cn(
        "mx-auto flex w-full max-w-7xl flex-wrap items-center justify-between gap-4 px-4 py-8 text-xs leading-relaxed text-gf-text-muted sm:px-8",
        className,
      )}>
      <span className="flex items-center gap-2">
        <LockKeyhole className="size-3.5" />
        {comparing
          ? "No account needed to compare rates."
          : "Save your application and return when you’re ready."}
      </span>
      <div className="flex gap-5">
        <a
          href="/privacy"
          target="_blank"
          rel="noreferrer"
          className="underline">
          Privacy
        </a>
        <a href="/terms" target="_blank" rel="noreferrer" className="underline">
          Terms
        </a>
      </div>
      <p className="w-full max-w-3xl">
        {MYGA_AGENCY_DISCLOSURE} Annuities are insurance products, not bank
        deposits. {MYGA_GUARANTEE_DISCLOSURE} {MYGA_ISSUANCE_DISCLOSURE}
      </p>
    </footer>
  );
}
